import gql from 'graphql-tag';

export const FishingMethodFragments = {
  id: gql`
    fragment FishingMethodId on FishingMethod {
      _id: externalId
    }
  `,
};
